import { render, staticRenderFns } from "./SoftwareMFA.vue?vue&type=template&id=05f2ca9f&scoped=true"
import script from "./SoftwareMFA.vue?vue&type=script&lang=js"
export * from "./SoftwareMFA.vue?vue&type=script&lang=js"
import style0 from "./SoftwareMFA.vue?vue&type=style&index=0&id=05f2ca9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2ca9f",
  null
  
)

export default component.exports